export class DropDownMenuSection {
  public header: DropDownMenuHeader;
  public items: DropDownMenuItem[];
  constructor(header: DropDownMenuHeader, items: DropDownMenuItem[]) {
    this.header = header;
    this.items = items;
  }
}

export class DropDownMenuHeader {
  public title: string;
  constructor(title: string) {
    this.title = title;
  }
}

export class DropDownMenuItem {
  public title: string;
  public value: any;
  public styling: Set<string>;

  constructor(title: string, value: any, styling?: Set<string>) {
    this.title = title;
    this.value = value;
    if (styling) {
      this.styling = styling;
    } else {
      this.styling = new Set<string>();
    }
  }
}
